/* eslint-disable import/prefer-default-export */
export { default as Api } from './api';

export const GAME_ICON_LIST = [
    {
        id: 'capybara',
        cardType: 'game',
        title: 'game.content1.game14.title',
        mobileIcon: require('@/assets/img/game-detail/game-capybara/game_icon_capybara.png'),
        pcIcon: require('@/assets/img/game-detail/game-capybara/game_icon_capybara.png'),
        isShow: true
    },
    {
        id: 'archero2',
        cardType: 'game',
        title: 'game.content1.game15.title',
        mobileIcon: require('@/assets/img/game-detail/game-archero2/game_icon_archero2.png'),
        pcIcon: require('@/assets/img/game-detail/game-archero2/game_icon_archero2.png'),
        isShow: true
    },
    {
        id: 'survivor',
        cardType: 'game',
        title: 'game.content1.game8.title',
        mobileIcon: require('@/assets/img/game-detail/game-survivor/icon.png'),
        pcIcon: require('@/assets/img/game-detail/game-survivor/icon.png'),
        isShow: true
    },
    {
        id: 'archero',
        cardType: 'game',
        title: 'game.content1.game1.title',
        mobileIcon: require('@/assets/img/game-detail/game-archero/archero-icon.png'),
        pcIcon: require('@/assets/img/game-detail/game-archero/archero-icon@2x.png'),
        isShow: true
    },
    {
        id: 'punball',
        cardType: 'game',
        title: 'game.content1.game3.title',
        mobileIcon: require('@/assets/img/game-detail/game-punball/icon.png'),
        pcIcon: require('@/assets/img/game-detail/game-punball/icon@2x.png'),
        isShow: true
    }
];
